import { generateCompanyFilters } from './companyFilters';
import { generateValueFilters } from './valueFilters';
import { generateFuturePerformanceFilters } from './futurePerformance';
import { generatePastFilters } from './pastFilters';
import { generateHealthFilters } from './healthFilters';
import { generateDividendsFilters } from './dividendsFilter';
import { generateManagementFilters } from './managementFilters';
import { generateOtherFilters } from './otherFilters';

export type RuleFunction = (range: number[] | boolean) => string;
export type TitleFormatterFunction = (rules: (number | string)[]) => string;
export type RuleToValueFunction = (
  rules: (number | string)[]
) => (number | string)[] | number | string;
export interface CustomCompanyFilter {
  id: string;
  label: string;
  subLabel?: string;
  defaultValue: string;
  labels?: Record<string, string>;
  max?: number;
  min?: number;
  rule?: string | RuleFunction;
  ruleToValue?: RuleToValueFunction;
  softMax?: number;
  softMin?: number;
  step?: number;
  titleFormatter?: TitleFormatterFunction;
  type?: string;
  valueResolver?: ((range: number) => number) | ((range: number[]) => number[]);
  untoggledRule?: string;
}

export const filterGroups: {
  label: string;
  filters: CustomCompanyFilter[];
}[] = [
  { label: 'Company', filters: generateCompanyFilters() },
  { label: 'Valuation', filters: generateValueFilters() },
  {
    label: 'Future Growth Estimate',
    filters: generateFuturePerformanceFilters(),
  },
  { label: 'Past Performance', filters: generatePastFilters() },
  { label: 'Financial Health', filters: generateHealthFilters() },
  { label: 'Dividends', filters: generateDividendsFilters() },
  { label: 'Management', filters: generateManagementFilters() },
  { label: 'Other', filters: generateOtherFilters() },
];
